class Timer {
    constructor(callback, duration) {
        this.callback = callback
        this.duration = duration
        this.timeout = null
    }

    start() {
        this.timeout = setTimeout(this.callback, this.duration)
    }

    stop() {
        if (this.timeout) {
            clearTimeout(this.timeout)
            this.timeout = null
        }
    }
}

export default (...args) => new Timer(...args)